// ** 경기 설정 유틸리티 **

// event: 145M, 90M, 70M, 30M
// 과녁마다 2개 조가 경기

// event에 따라 조당 선수 수 결정
export const getPlayersPerGroup = (event) => {
  // 145M: 조당 7명
  // 90M, 70M, 30M: 조당 2명
  return event === "145" ? 7 : 2;
};

// 날짜(YYYY-MM-DD)별 과녁 개수: [145m, 30/70/90m]
// 2026 예선(10/31 ~ 11/2)은 해외 과녁 1~32번, 궁도 1~5관. 2026 본선(11/3, 11/4)은 2025와 같다고 가정
const TARGET_COUNTS = {
  "2025-11-01": [6, 18],
  "2025-11-02": [6, 18],
  "2025-11-03": [6, 16],
  "2025-11-04": [4, 4],
  "2026-10-31": [5, 32],
  "2026-11-01": [5, 32],
  "2026-11-02": [5, 32],
  "2026-11-03": [6, 16],
  "2026-11-04": [4, 4],
};

// date, event에 따라 과녁 개수 결정
export const getTargetCount = (date, event) => {
  const distance = event.replace("M", "");
  const counts = TARGET_COUNTS[date];
  if (!counts) return 0;

  return distance === "145" ? counts[0] : counts[1];
};

// 연도별 예선 날짜
export const PRELIM_DATES = {
  2025: ["2025-11-01", "2025-11-02"],
  2026: ["2026-10-31", "2026-11-01", "2026-11-02"],
};

// 연도별 본선(16강~결승) 날짜
export const TOURNAMENT_DATES = {
  2025: ["2025-11-03", "2025-11-04"],
  2026: ["2026-11-03", "2026-11-04"],
};

// 예선 날짜 선택이 필요한 종목: 2025는 전 종목을 이틀에 나눠 함, 2026은 145m만 사흘(30/70/90m는 하루씩이라 경기일 자동 선택)
export const hasPrelimDateSelect = (year, distance) =>
  Number(year) < 2026 || distance === "145";

// 원작대 경기 단계: 예선 + 본선(16강~결승). 본선 값은 서버 JO_TYPE 앞자리 ("16-30" = 30m 16강)
export const TARGET_STAGES = ["PRE", "16", "8", "4", "3", "2"];

// 원작대에서 본선을 고를 수 있는 연도 (2026 본선은 경기 시간이 아직 없어 원작대에 나올 데이터가 없음)
export const hasTournamentTargets = (year) => Number(year) < 2026;

// 본선 단계의 경기일: 16강~4강 첫날, 3/4위전·결승 둘째 날
export const stageDate = (year, stage) =>
  TOURNAMENT_DATES[year]?.[Number(stage) >= 4 ? 0 : 1];

// 조가 고른 단계인지 (jo_type이 없는 이전 서버 응답은 모두 예선으로 봄)
export const matchesStage = (joType, stage, distance) =>
  joType
    ? joType === (stage === "PRE" ? "PRE" : `${stage}-${distance}`)
    : stage === "PRE";

const WEEKDAYS = {
  ko: ["일", "월", "화", "수", "목", "금", "토"],
  en: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
};

// "2026-10-31" → "10.31(토)" / "10.31 (Sat)"
export const dateLabel = (date, language = "ko") => {
  const [, month, day] = date.split("-").map(Number);
  const weekday = new Date(date).getDay();
  return language === "ko"
    ? `${month}.${day}(${WEEKDAYS.ko[weekday]})`
    : `${month}.${day} (${WEEKDAYS.en[weekday]})`;
};

// 조 번호 → 공지의 조 이름 (2026: 1~9 = A-1 ~ C-3, 10 = 11/2 대표자 조)
export const squadLabel = (year, group) => {
  const n = Number(group);
  if (year !== "2026" || !n) return group;
  if (n === 10) return "REP";
  return `${"ABC"[Math.floor((n - 1) / 3)]}-${((n - 1) % 3) + 1}`;
};
